/**
 * Hour-display helpers for Mon Espace.
 *
 * Worked/planned time is always rendered as real hours+minutes ("38h18"),
 * never decimal hours ("38.3h") — users read the decimal as hours+minutes
 * (38.3 → "38h30"), so subtracting 30 min looked broken ("37h80").
 */

/** 2298 → "38h18" (minutes zero-padded, clamped at 0). */
export const formatMinutesAsHM = (minutes: number): string => {
  const safe = Math.max(0, Math.round(minutes));
  const h = Math.floor(safe / 60);
  const m = safe % 60;
  return `${h}h${String(m).padStart(2, '0')}`;
};

/** 38.3 → "38h18". */
export const formatHoursAsHM = (decimalHours: number): string =>
  formatMinutesAsHM(decimalHours * 60);

/** +3.5 → "+3h30", −2.25 → "-2h15", 0 → "0h00". For the récup balance. */
export const formatSignedHoursAsHM = (decimalHours: number): string => {
  const sign = decimalHours < 0 ? '-' : decimalHours > 0 ? '+' : '';
  return sign + formatHoursAsHM(Math.abs(decimalHours));
};
